import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAxiosContext } from "../../context/AxiosContext";
import Input from "../../components/FormComponents/Input";
import Button from "../../components/FormComponents/Button";
import resetPassword from "../../images/resetPassword.svg";
import waveBg from "../../images/svg/loginWavetop.svg";
import loginDown from "../../images/svg/login-mg-down.svg";
import zinoLogo from "../../images/svg/zinoLogo.svg";
import newPassword from "../../images/newPassword.svg";
import { useAuth0Context } from "../../context/Auth0Context";
import { encryptData } from "./Login";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [currentStep, setCurrentStep] = useState("1");
  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();
  const location = useLocation();
  const [query, setQuery] = useState({
    emailParams: "",
    codeParams: ""
  });
  const { isAuthenticate } = useAuth0Context();
  const [loading, setLoading] = useState(false);

  const handleLoginData = (e) => {
    setEmail(e.target.value);
  };

  const handleSendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { message } = await axiosInstance.put(`/forgetPassword`, { email: encryptData(email) });
      setCurrentStep("2");
      handleSuccess(message);
    } catch (error) {
      handleError(error);
      // toast.error("error")
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get("email");
    const code = queryParams.get("code");
    if (email && code) {
      setCurrentStep("3");
      setQuery({
        emailParams: email,
        codeParams: code
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (isAuthenticate) {
      navigate("/organization");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticate]);

  return (
    <div className="login_outer_container">
      <MaterialIcon name="arrow_back_ios" onClick={() => navigate("../login")} />
      <div className="login-page-img-wrap">
        <img className="login-wave-bg" src={waveBg} alt="wave bg" />
        {currentStep === "1" && (
          <img
            className="login-img"
            src={resetPassword}
            alt="reset password"
            width="450px"
            height="500px"
            style={{ marginRight: "50px" }}
          />
        )}
        {currentStep === "3" && (
          <img
            src={newPassword}
            alt="create new password"
            width="450px"
            height="500px"
            style={{ marginRight: "50px" }}
          />
        )}

        <img className="login-img-down" src={loginDown} alt="login bg down" />
      </div>

      <div className="login-right-section">
        <div className="logo-in-login">
          <img src={zinoLogo} alt="zino logo" />
        </div>
        <div className="login_inner_container reset-label">
          <div>
            <h1>Reset Password</h1>
            <div className="builder_form login-form">
              {currentStep === "1" && (
                <>
                  <Input
                    label="Email"
                    type="email"
                    value={email}
                    name="email"
                    onChange={handleLoginData}
                    placeholder="Enter Email ID"
                  />

                  <Button
                    onClick={handleSendEmail}
                    disabled={loading}
                    style={{ maxWidth: "unset", margin: "18px 0px 0px 0px" }}
                  >
                    {loading ? <span className="login_spinner" /> : "Send Email"}
                  </Button>
                </>
              )}
              {currentStep === "2" && (
                <div className="builder_form">
                  <label className="builder_label">Check mail for reset password</label>
                  <Button
                    variant="secondary"
                    onClick={handleSendEmail}
                    style={{ maxWidth: "unset", margin: "12px 0px 0px" }}
                    disabled={loading}
                  >
                    {loading ? <span className="login_spinner" /> : "Resend Email"}
                  </Button>
                </div>
              )}
              {currentStep === "3" && <ResetPassword query={query} setCurrentStep={setCurrentStep} />}

              {currentStep === "4" && (
                <div className="builder_form">
                  <label className="builder_label">Password reset successfully</label>
                  <Button
                    variant="secondary"
                    onClick={() => navigate("../login")}
                    style={{ maxWidth: "unset", margin: "12px 0px 0px" }}
                  >
                    Back to login
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ResetPassword = ({ query, setCurrentStep }) => {
  const [verifyData, setVerifyData] = useState({
    code: "",
    email: "",
    new_password: "",
    re_password: ""
  });
  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();
  const [error, setError] = useState("");
  const handleInputChange = (e) => {
    setError("");
    const { name, value } = e.target;
    setVerifyData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };
  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
      if (verifyData.new_password.length < 4) {
        setError("length");
        return;
      }
      if (verifyData.new_password !== verifyData.re_password) {
        setError("new");
        return;
      }
      const { message } = await axiosInstance.put(`/verifyPassword`, {
        code: verifyData.code,
        email: encryptData(verifyData.email),
        new_password: encryptData(verifyData.new_password)
      });
      handleSuccess(message);
      setCurrentStep("4");
      // navigate("../login");
    } catch (error) {
      if (error?.response?.data?.message === "Reset code verification failed") setError("code");
      else setError("email");
      handleError(error);
    }
  };
  useEffect(() => {
    if (query.emailParams && query.codeParams) {
      setVerifyData((prevData) => ({
        ...prevData,
        email: query.emailParams,
        code: query.codeParams
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // /resetpassword?email=xyz@example.com&code=123456
  return (
    <div className="builder_form">
      <Input
        label="New Password"
        value={verifyData.new_password}
        name="new_password"
        onChange={handleInputChange}
        placeholder="password"
      />
      {error === "length" && <label className="builder_label label_error">Password should be atleast 4 digits</label>}

      <Input
        label="Re-enter New Password"
        value={verifyData.re_password}
        name="re_password"
        onChange={handleInputChange}
        placeholder="password"
        containerStyle={{ marginBottom: "12px" }}
      />
      {error === "new" && <label className="builder_label label_error">Password did not match</label>}

      <Button onClick={handleResetPassword} style={{ maxWidth: "unset" }}>
        Reset Password
      </Button>
    </div>
  );
};
export default ForgotPassword;
